import { render, staticRenderFns } from "./TenancyDepositShares.vue?vue&type=template&id=6168818d"
import script from "./TenancyDepositShares.vue?vue&type=script&lang=js"
export * from "./TenancyDepositShares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports